import { useEffect, useState } from "react";
import { useI18n } from "../i18n";

const AboutHero = () => {
    const { about } = useI18n();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const frame = requestAnimationFrame(() => setVisible(true));
        return () => cancelAnimationFrame(frame);
    }, []);

    return (
        <>
            <section className="bg-slate-50 px-6  md:px-12">
                <div className="mx-auto max-w-7xl pt-24">
                    <p className="mb-4 text-xs font-bold uppercase tracking-[0.22em] text-sky-700 sm:text-sm mt-8 md:mt-16">
                        {about.companyName}
                    </p>

                    <div className="space-y-5 text-base leading-8 text-slate-600 md:text-lg">
                        <p>{about.companyDescription}</p>

                        <p>{about.companyGoal}</p>
                    </div>
                </div>
            </section>
            <section className="relative isolate overflow-hidden bg-slate-50 px-6 pb-20 pt-3 md:px-12 md:pb-28">
                {/* Abstract background */}
                <div
                    aria-hidden="true"
                    className="pointer-events-none absolute inset-0 -z-10 overflow-hidden"
                >
                    <div className="absolute -right-32 -top-40 h-[28rem] w-[28rem] rounded-full bg-sky-200/50 max-sm:hidden" />

                    <div className="absolute -bottom-40 -left-32 h-[30rem] w-[30rem] rounded-full bg-blue-100/70 " />

                    <div
                        className="absolute inset-0 opacity-[0.035]"
                        style={{
                            backgroundImage:
                                "linear-gradient(to right, #334155 1px, transparent 1px), linear-gradient(to bottom, #334155 1px, transparent 1px)",
                            backgroundSize: "55px 55px",
                        }}
                    />

                    <svg
                        className="absolute inset-0 h-full w-full"
                        viewBox="0 0 1440 700"
                        preserveAspectRatio="xMidYMid slice"
                        fill="none"
                    >
                        <defs>
                            <linearGradient
                                id="aboutHeroGradient"
                                x1="0"
                                y1="0"
                                x2="1440"
                                y2="700"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stopColor="#38BDF8" stopOpacity="0" />
                                <stop offset=".5" stopColor="#38BDF8" stopOpacity=".5" />
                                <stop offset="1" stopColor="#6366F1" stopOpacity="0" />
                            </linearGradient>
                        </defs>

                        <path
                            d="M-100 500C200 300 350 650 650 420S1100 200 1540 400"
                            stroke="url(#aboutHeroGradient)"
                            strokeWidth="1.5"
                        />

                        <path
                            d="M800 -100C900 100 1100 150 1300 50S1500 150 1600 250"
                            stroke="url(#aboutHeroGradient)"
                            strokeWidth="1.5"
                        />

                        <circle
                            cx="1150"
                            cy="180"
                            r="100"
                            stroke="#38BDF8"
                            strokeOpacity=".25"
                        />

                        <circle
                            cx="1150"
                            cy="180"
                            r="125"
                            stroke="#38BDF8"
                            strokeOpacity=".15"
                        />
                    </svg>
                </div>

                <div className="mx-auto max-w-7xl">
                    <div
                        className={`about-hero-content ${visible ? "about-hero-visible" : ""
                            }`}
                    >

                        <h1 className="max-w-4xl text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl md:text-7xl">
                            {about.heroTitle}
                        </h1>

                        <p className="mt-6 max-w-2xl text-base leading-7 text-slate-600 sm:text-lg sm:leading-8">
                            {about.heroDescription}
                        </p>

                        <div className="mt-8 h-1 w-24 rounded-full bg-gradient-to-r from-sky-500 to-blue-400" />
                    </div>
                </div>

                <style>{`
                .about-hero-content {
                    opacity: 0;
                    transform: translateY(14px);
                    transition:
                        opacity 450ms ease-out,
                        transform 450ms ease-out;
                }

                .about-hero-visible {
                    opacity: 1;
                    transform: translateY(0);
                }

                @media (prefers-reduced-motion: reduce) {
                    .about-hero-content {
                        opacity: 1;
                        transform: none;
                        transition: none;
                    }
                }
            `}</style>
            </section>
        </>
    );
};

export default AboutHero;